<script>
  import { format } from 'svelte-i18n';
  import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from '@sveltestrap/sveltestrap';

  import Pusher from './pusher.svelte';

  export let config = undefined;
  export let show = false;

  let pushed = false;

  const toggle = () => (show = false);
</script>

{#if show}
  <Modal class="modal-wizard" isOpen size="lg" fullscreen="lg" {toggle} {...$$restProps}>
    <ModalHeader class="text-center" {toggle}>
      {$format('label.NEW_PUSH')}
    </ModalHeader>
    <ModalBody>
      <Pusher {config} bind:pushed />
    </ModalBody>
    <ModalFooter>
      <Button on:click={toggle}>
        {$format(pushed ? 'label.CLOSE' : 'label.CANCEL')}
      </Button>
    </ModalFooter>
  </Modal>
{/if}
